import { FormGroupProps, FormGroup as MuiFormGroup } from "@mui/material";

type Props = FormGroupProps;

export const FormGroup = ({ children, ...props }: Props) => {
  return <MuiFormGroup {...props}>{children} </MuiFormGroup>;
};
